import { render, staticRenderFns } from "./SpecialColumnManage.vue?vue&type=template&id=df29ff58&scoped=true"
import script from "./SpecialColumnManage.vue?vue&type=script&lang=js"
export * from "./SpecialColumnManage.vue?vue&type=script&lang=js"
import style0 from "./SpecialColumnManage.vue?vue&type=style&index=0&id=df29ff58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df29ff58",
  null
  
)

export default component.exports